// Онбординг, экран 4 — «Готово» (план §5.3).
//
// Единственное действие экрана — `onboarding.complete` и уход на дашборд.
// Последовательность (отмена рефетчей → синхронное гашение флага в кэше →
// фоновая сверка; уход — когда контекст сессии увидит снятый флаг) живёт в `use-onboarding-exit.ts`: она
// защищает от инцидента «двойной онбординг», и копия этой логики в теле экрана —
// ровно тот способ, которым инцидент вернётся.

import { CategoryTile } from "@studyhub/ui/components/studyhub/category-tile";
import { IconCheck } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CoursePathsExplainer } from "@/components/how-it-works/course-paths-explainer";
import { trackOnboardingCompleted } from "@/components/onboarding/_analytics";
import { OnboardingStepLayout } from "@/components/onboarding/onboarding-step-layout";
import { useOnboardingExit } from "@/components/onboarding/use-onboarding-exit";
import { useOnboardingStep } from "@/components/onboarding/use-onboarding-step";

export const Route = createFileRoute("/onboarding/done")({
	component: DonePage,
});

function DonePage(): React.ReactElement {
	const { t } = useTranslation("onboarding");
	const step = useOnboardingStep("done");
	const { finish, isPending } = useOnboardingExit();

	// Событие «дошёл до конца» — на ПОКАЗЕ финала, а не на нажатии кнопки:
	// человек, закрывший вкладку на этом экране, онбординг всё равно прошёл, и
	// воронка не должна считать его отвалившимся.
	useEffect(() => {
		trackOnboardingCompleted();
	}, []);

	return (
		<OnboardingStepLayout
			stepNumber={step.stepNumber}
			onBack={step.goBack}
			onNext={finish}
			nextLabel={t("done.cta")}
			isNextLoading={isPending}
		>
			<div className="flex flex-col items-start gap-4">
				<CategoryTile aria-hidden category="mastery" size="xl" icon={<IconCheck stroke={2} />} />
				<div className="space-y-2">
					<h2 className="text-xl font-semibold tracking-tight text-foreground">
						{t("done.title")}
					</h2>
					<p className="text-base text-muted-foreground">{t("done.lead")}</p>
				</div>
			</div>

			{/* Три сценария — ИЛЛЮСТРАЦИЯ к фразе выше, а не выбор: компонент без
			    действий (см. его шапку), и своего лида здесь не показывает.
			    Экран «С чего начнём» убран из мастера именно затем, чтобы решение
			    не требовалось прямо сейчас; здесь человек просто видит, что
			    дальше возможно. */}
			<CoursePathsExplainer variant="compact" withIntro={false} />
		</OnboardingStepLayout>
	);
}
